<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>

export default {
  data() {
    return {
      programSections : [],
    }
  },
  beforeMount() {
    let that = this;
    this.axios.get('https://sfsi.ru/api/smart-workout/all')
        .then((response) => {
          that.programSections = response.data;
        })
  },
}
</script>

